import { render, staticRenderFns } from "./ShopSalesChart.vue?vue&type=template&id=473b33b3&scoped=true&lang=pug&"
import script from "./ShopSalesChart.vue?vue&type=script&lang=js&"
export * from "./ShopSalesChart.vue?vue&type=script&lang=js&"
import style0 from "./ShopSalesChart.vue?vue&type=style&index=0&id=473b33b3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b33b3",
  null
  
)

/* custom blocks */
import block0 from "./ShopSalesChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports